import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-dealer-data',
  templateUrl: './import-dealer-data.component.html',
  styleUrls: ['./import-dealer-data.component.scss']
})
export class ImportDealerDataComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
